var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJavaScript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    fill: "#FF4D4D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15H65V65H15V15V15Z",
    fill: "#FF4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1466 56.7836L31.9729 54.468C32.7111 55.7768 33.3826 56.8842 34.9933 56.8842C36.5373 56.8842 37.5107 56.2802 37.5107 53.931V37.9548H42.2094V53.9975C42.2094 58.8641 39.3567 61.0793 35.1947 61.0793C31.4359 61.0793 29.254 59.1325 28.1465 56.7832",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7617 56.2802L48.5876 54.0651C49.5947 55.7099 50.9037 56.918 53.2194 56.918C55.1663 56.918 56.4078 55.9446 56.4078 54.6021C56.4078 52.991 55.1325 52.4204 52.9844 51.481L51.8101 50.9772C48.42 49.5342 46.1712 47.7218 46.1712 43.8956C46.1712 40.3714 48.8562 37.6863 53.0517 37.6863C56.0389 37.6863 58.1869 38.7268 59.7306 41.4455L56.0722 43.7948C55.2666 42.3517 54.3943 41.7812 53.0518 41.7812C51.6757 41.7812 50.803 42.6538 50.803 43.7948C50.803 45.2045 51.6757 45.7752 53.6893 46.6479L54.8639 47.1513C58.8579 48.8631 61.1067 50.6082 61.1067 54.5349C61.1067 58.7641 57.784 61.0798 53.3202 61.0798C48.957 61.0798 46.1377 58.999 44.7618 56.2802",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaScript);
export default __webpack_public_path__ + "static/media/JavaScript.187384ffed71a55eb54734f44e5d0a3d.svg";
export { ForwardRef as ReactComponent };